import { createAsyncAction } from 'typesafe-actions';
import { ApiConfigurationResponse } from '../../../models/api-configuration/api-configuration.model';
import { ErrorNormalized } from '../../../models/errors/error.model';

export const apiConfigurationAsync = createAsyncAction(
    'API_CONFIGURATION:REQUEST',
    'API_CONFIGURATION:SUCCESS',
    'API_CONFIGURATION:FAILURE'
)<undefined, ApiConfigurationResponse, ErrorNormalized>();
